import { SplitFactory } from '@splitsoftware/splitio'

const config = {}
let client, factory

/**
 * https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK
 */
function SplitioPlugin(userConfig = {}) {
  return {
    NAMESPACE: 'splitio',
    config: { ...config, ...userConfig },
    initialize,
    bootstrap: ({ config, instance }) => {
      /* Load segment script after userId exists */
      if (config.disableAnonymousTraffic && !instance.user('userId'))
        instance.once('identifyStart', ({ plugins }) => {
          const self = plugins['splitio']
          if (!self.loaded()) instance.loadPlugin('splitio')
        })
    },
    page: ({ payload: { properties } }) => {
      client.track('user', 'pageview', null, properties)
    },
    track: ({ payload: { event, properties } }) => {
      client.track('user', event, properties?.value, properties)
    },
    identify: ({ payload: { userId, traits } }) => {
      client = factory.client(userId, 'user')
    },
    loaded: () => {
      return client && factory
    },
  }
}

export default SplitioPlugin

export function initialize({ config, instance, payload }) {
  console.info('anonymous', instance.user('anonymousId'))

  factory = SplitFactory({
    core: {
      authorizationKey: config.authorizeKey || 'localhost',
      key: 'default',
    },
    features: {
      reporting_v2: 'on',
    },
  })

  client = factory.client()

  return client
}

declare module '@splitsoftware/splitio/types' {
  export function SplitFactory(settings: SplitIO.IBrowserSettings): SplitIO.ISDK
}
